import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <h2>A New Legend Begins...</h2>
      <p>The digital realm holds its breath. Soon, the gates will open for challengers to forge their legacy in code and creativity. Prepare yourselves.</p>
    </div>
  );
};

export default Home;
